import React from 'react';

export const DashboardTicketsVariationCards = ({
    summary,
    previousSummary,
    variation,
    formatNumber,
    formatVariation,
    variationClass,
}) => {
    return (
        <div className="row g-3 mb-3">
            <div className="col-12 col-lg-3">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación tickets</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.totalTickets)}</div>
                        <div className={`fw-semibold ${variationClass(variation?.totalTickets)}`}>{formatVariation(variation?.totalTickets)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.totalTickets)})</div>
                </div>
            </div>

            <div className="col-12 col-lg-3">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación abiertos</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.openTickets)}</div>
                        <div className={`fw-semibold ${variationClass(variation?.openTickets)}`}>{formatVariation(variation?.openTickets)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.openTickets)})</div>
                </div>
            </div>

            <div className="col-12 col-lg-3">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación resueltos</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.resolvedTickets)}</div>
                        <div className={`fw-semibold ${variationClass(variation?.resolvedTickets)}`}>{formatVariation(variation?.resolvedTickets)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.resolvedTickets)})</div>
                </div>
            </div>

            <div className="col-12 col-lg-3">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación fuera SLA</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.breachedResolvedTickets)}</div>
                        <div className={`fw-semibold ${variationClass(variation?.breachedResolvedTickets)}`}>{formatVariation(variation?.breachedResolvedTickets)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.breachedResolvedTickets)})</div>
                </div>
            </div>
        </div>
    );
};
